import { Component } from 'react';

class Header extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="registration-header">
                    <div>
                        <img
                            className="logo-symbol"
                            src="/static/img/gddash_logo1.png"
                            alt="logo"
                        />
                    </div>
                </div>
                <div className="registration-header-message">
                    <div className="col-12">
                        <div className="elementor-alert d-flex width-full" role="alert">
                            <div href="/" className="logo">
                                <i className="icon-website"></i>
                            </div>
                            <div>
                                <span className="elementor-alert-title">Supported Languages</span>
                                <span className="elementor-alert-description">
                                    Currently, we ONLY support the following languages for Discover
                                    Analytics: Arabic, Chinese (Simplified), Chinese (Traditional),
                                    Czech, Danish, Dutch, English, Finnish, French, German, Hebrew,
                                    Hindi, Italian, Japanese, Korean, Norwegian, Norwegian (Bokmal),
                                    Norwegian (Nyorsk), Polish, Portuguese, Romanian, Russian,
                                    Slovak, Spanish, Swedish, Turkish.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Header;
